import React from 'react'
import { format } from 'date-fns'

import { translate } from 'locales'

import * as S from './styles'

const Footer = () => {
  return (
    <S.Container>
      <div className="legal">
        {`© Copyright 2020-${format(new Date(), 'yyyy')} Starbem - ${translate(
          'general.allRightsReserved'
        )} `}
        <strong>| Versão: 2.3.9</strong>
      </div>
    </S.Container>
  )
}

export default Footer
